/**
 * Category mapping utilities for assessment
 */
import { Category } from '../models';

// Display names for categories
export const categoryDisplayNames: Record<Category, string> = {
  'strategy-alignment': 'Strategy & Alignment',
  'people': 'People',
  'portfolio-reporting': 'Portfolio Reporting',
  'scalability-growth': 'Scalability & Growth',
  'tech-tools': 'Tech & Tools',
  'value-focus': 'Value Focus',
  'change-transformation': 'Change & Transformation',
  'process-governance': 'Process & Governance'
};

// Category colors for charts
export const categoryColors: Record<Category, string> = {
  'strategy-alignment': '#2A9D8F',
  'people': '#E9C46A',
  'portfolio-reporting': '#F4A261',
  'scalability-growth': '#E76F51',
  'tech-tools': '#264653',
  'value-focus': '#8AB17D',
  'change-transformation': '#9B5DE5',
  'process-governance': '#00BBF9'
};

// Category icons (can be replaced with actual icon components)
export const categoryIcons: Record<Category, string> = {
  'strategy-alignment': 'target',
  'people': 'users',
  'portfolio-reporting': 'chart-bar',
  'scalability-growth': 'trending-up',
  'tech-tools': 'tool',
  'value-focus': 'dollar-sign',
  'change-transformation': 'refresh-cw',
  'process-governance': 'shield'
};

// Get category display name
export const getCategoryDisplayName = (category: Category): string => {
  return categoryDisplayNames[category] || category;
};

// Get category color
export const getCategoryColor = (category: Category): string => {
  return categoryColors[category] || '#cccccc';
};

// Get category icon
export const getCategoryIcon = (category: Category): string => {
  return categoryIcons[category] || 'help-circle';
};
